<footer class="footer">
  <div class="layout">
    <nav class="navigation">
      <ul class="footer-list">
        <li class="footer-item">
          <span class="footer-link" (click)="privacyPolicyShow()">Privatlivspolitik og Databeskyttelse</span>
        </li>
      </ul>
    </nav>
  </div>
</footer>
